import React, { useState } from "react";
import Step from "../components/profilesetup/step.tsx";
import Step2 from "../components/profilesetup/step2.tsx";
import Step3 from "../components/profilesetup/step3.tsx";

interface UserDetails {
    ID: string;
    Userid: string;
    Company: string | null;
    Position: string | null;
    CreatedAt: string;
    Phone: string | null;
    Email: string;
    Linkedin: string | null;
    Github: string | null;
}
interface ProfileSetupWizardProps {
    userData: UserDetails | null;
}


const ProfileSetupWizard: React.FC<ProfileSetupWizardProps> = ({ userData }) => {
    const [formData, setFormData] = useState({
        name: userData?.Userid,
        email: userData?.Email,
        phone: userData?.Phone || "",
        linkedin: userData?.Linkedin || "",
        github: userData?.Github || "",
        website: "",
        summary: "",
        experience: [{ company: "", role: "", startDate: "", endDate: "", present: false, description: "" }],
        education: [{ institution: "", degree: "", fieldOfStudy: "", duration: "" }],
        skills: [""],
        certifications: [{ name: "", issuingOrganization: "", date: "" }]
    });
    const [currentStep, setCurrentStep] = useState(1);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleArrayChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number, arrayName: string) => {
        const { name, value, type, checked } = e.target as HTMLInputElement;
        const updatedArray = [...formData[arrayName]];
        if (arrayName === "skills") {
            updatedArray[index] = value;
        } else {
            updatedArray[index] = { ...updatedArray[index], [name]: type === "checkbox" ? checked : value };
        }
        setFormData(prevState => ({
            ...prevState,
            [arrayName]: updatedArray
        }));
    };

    const handleAddEntry = (arrayName: string, newEntry: any) => {
        setFormData(prevState => ({
            ...prevState,
            [arrayName]: [...prevState[arrayName], newEntry]
        }));
    };

    const handleRemoveEntry = (arrayName: string, index: number) => {
        const updatedArray = formData[arrayName].filter((_, i) => i !== index);
        setFormData(prevState => ({
            ...prevState,
            [arrayName]: updatedArray
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            const response = await fetch('/candidate/profile/setup', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            if (response.ok) {
                // Handle successful profile setup
                console.log('Profile setup successful');
            } else {
                // Handle error
                console.error('Profile setup failed');
            }
        } catch (error) {
            console.error('Error submitting profile setup:', error);
        }
    };

    const nextStep = () => {
        setCurrentStep(prevStep => prevStep + 1);
    };

    const previousStep = () => {
        setCurrentStep(prevStep => prevStep - 1);
    };

    return (
        <div className="container mx-auto p-4">
            <h1 className="text-2xl font-bold mt-4">Profile Setup Wizard</h1>
            <p className="mt-4">Please complete your profile setup.</p>
            <form onSubmit={handleSubmit} className="mt-4 space-y-6">
                {currentStep === 1 && (
                    <Step formData={formData} handleChange={handleChange} />
                )}
                {currentStep === 2 && (
                    <Step2
                        formData={formData}
                        handleArrayChange={handleArrayChange}
                        handleAddEntry={handleAddEntry}
                        handleRemoveEntry={handleRemoveEntry}
                    />

                )}
                {currentStep === 3 && (
                    <Step3
                        formData={formData}
                        handleArrayChange={handleArrayChange}
                        handleAddEntry={handleAddEntry}
                        handleRemoveEntry={handleRemoveEntry}
                    />

                )}
                <div className="flex justify-between">
                    {currentStep > 1 && (
                        <button type="button" onClick={previousStep} className="text-blue-500">Previous</button>
                    )}
                    {currentStep < 3 ? (
                        <button type="button" onClick={nextStep} className="text-blue-500">Next</button>
                    ) : (
                        <button type="submit" className="text-blue-500">Submit</button>
                    )}
                </div>
            </form>
        </div>
    );
};

export default ProfileSetupWizard;